document.addEventListener("DOMContentLoaded", function () {
    function getUpcartRoot() {
        if (typeof upcartDocumentOrShadowRoot !== "undefined" && upcartDocumentOrShadowRoot) {
            return upcartDocumentOrShadowRoot;
        }
        if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot;
        return document;
    }

    function getItemUnitPrice(item) {
        if (!item || typeof item !== "object") return 0;
        if (typeof item.finalPrice === "number") return item.finalPrice;
        if (typeof item.originalPrice === "number") return item.originalPrice;
        if (typeof item.price === "number") return item.price;
        if (typeof item.final_price === "number") return item.final_price;
        if (typeof item.original_price === "number") return item.original_price;
        return 0;
    }

    function getItemLinePrice(item) {
        if (!item || typeof item !== "object") return 0;
        if (typeof item.finalLinePrice === "number") return item.finalLinePrice;
        if (typeof item.final_line_price === "number") return item.final_line_price;
        var qtyRaw = Number(item.quantity);
        var qty = qtyRaw > 0 ? qtyRaw : 1;
        return getItemUnitPrice(item) * qty;
    }

    function formatMoneyFromMinorUnits(amountInMinor, currencyCode) {
        var numeric = typeof amountInMinor === "number" ? amountInMinor : Number(amountInMinor || 0);
        var currency = currencyCode || "GBP";
        try {
            return new Intl.NumberFormat("en-GB", {
                style: "currency",
                currency: currency
            }).format(numeric / 100);
        } catch (error) {
            return "£" + (numeric / 100).toFixed(2);
        }
    }

    function parseMoneyToMinorUnits(text) {
        if (typeof text !== "string") return 0;
        var cleanedChars = [];
        for (var i = 0; i < text.length; i += 1) {
            var ch = text.charAt(i);
            var code = ch.charCodeAt(0);
            var isDigit = code >= 48 && code <= 57;
            if (isDigit || ch === "." || ch === "," || ch === "-") {
                cleanedChars.push(ch);
            }
        }
        var cleaned = cleanedChars.join("").trim();
        if (!cleaned) return 0;

        // Keep last separator as decimal point, remove all others.
        var lastDot = cleaned.lastIndexOf(".");
        var lastComma = cleaned.lastIndexOf(",");
        var decimalIndex = Math.max(lastDot, lastComma);

        var normalized;
        if (decimalIndex === -1) {
            var noSepChars = [];
            for (var j = 0; j < cleaned.length; j += 1) {
                var c = cleaned.charAt(j);
                if (c !== "." && c !== ",") noSepChars.push(c);
            }
            normalized = noSepChars.join("");
        } else {
            var intRaw = cleaned.slice(0, decimalIndex);
            var fracRaw = cleaned.slice(decimalIndex + 1);
            var intChars = [];
            var fracChars = [];

            for (var k = 0; k < intRaw.length; k += 1) {
                var intCh = intRaw.charAt(k);
                if (intCh !== "." && intCh !== ",") intChars.push(intCh);
            }
            for (var m = 0; m < fracRaw.length; m += 1) {
                var fracCh = fracRaw.charAt(m);
                if (fracCh !== "." && fracCh !== ",") fracChars.push(fracCh);
            }

            var intPart = intChars.join("");
            var fracPart = fracChars.join("");
            normalized = intPart + "." + fracPart;
        }

        var numeric = Number(normalized);
        if (Number.isNaN(numeric)) return 0;
        return Math.round(numeric * 100);
    }

    function getCartItemElements(upcartRoot) {
        var roots = [];
        if (upcartRoot) roots.push(upcartRoot);
        if (document && roots.indexOf(document) === -1) roots.push(document);

        var allFound = [];
        for (var r = 0; r < roots.length; r += 1) {
            var root = roots[r];
            if (!root || typeof root.querySelectorAll !== "function") continue;

            var directItems = root.querySelectorAll(".upcart-internal-cart-item.upcart-public-cart-item");
            for (var i = 0; i < directItems.length; i += 1) allFound.push(directItems[i]);

            // Fallback: build rows from price chunks.
            var priceNodes = root.querySelectorAll('[data-upcart-chunk="cart-item-price"]');
            for (var j = 0; j < priceNodes.length; j += 1) {
                var priceNode = priceNodes[j];
                var row = priceNode.closest(".upcart-internal-cart-item, .upcart-public-cart-item, li");
                if (row) allFound.push(row);
            }
        }

        // De-duplicate while preserving order.
        var unique = [];
        for (var k = 0; k < allFound.length; k += 1) {
            if (unique.indexOf(allFound[k]) === -1) unique.push(allFound[k]);
        }
        return unique;
    }

    function renderCartItemPricesToDom(upcartRoot, cart) {
        if (!upcartRoot || !cart || !Array.isArray(cart.items)) return;

        var itemEls = getCartItemElements(upcartRoot);
        if (!itemEls || !itemEls.length) {
            console.log("[UpCart] no cart item elements found in root");
            return;
        }

        var itemCount = Math.min(itemEls.length, cart.items.length);
        console.log("[UpCart] rendering item prices:", {
            domItems: itemEls.length,
            cartItems: cart.items.length,
            applied: itemCount
        });

        for (var i = 0; i < itemCount; i += 1) {
            var itemEl = itemEls[i];
            var cartItem = cart.items[i];
            if (!cartItem) continue;

            var priceEl = itemEl.querySelector('[data-upcart-chunk="cart-item-price"]');
            if (!priceEl && itemEl.matches && itemEl.matches('[data-upcart-chunk="cart-item-price"]')) {
                priceEl = itemEl;
            }
            if (!priceEl) continue;

            var savingsEl = itemEl.querySelector(".upcart-internal-component-product-tile__savings, .upcart-public-component-product-tile__savings");
            var priceGroupEl = itemEl.querySelector(".upcart-internal-component-product-tile__price-group, .upcart-public-component-product-tile__price-group");

            if (typeof cartItem.__kgForcedDisplayText === "string" && cartItem.__kgForcedDisplayText) {
                if (priceGroupEl) priceGroupEl.style.display = "none";
                if (savingsEl) {
                    savingsEl.textContent = cartItem.__kgForcedDisplayText;
                    savingsEl.style.display = "";
                }
                continue;
            }

            var baseDisplayed;
            if (priceEl.dataset.kgBaseMinorUnits) {
                baseDisplayed = Number(priceEl.dataset.kgBaseMinorUnits || 0);
            } else {
                baseDisplayed = parseMoneyToMinorUnits(priceEl.textContent || "");
                priceEl.dataset.kgBaseMinorUnits = String(baseDisplayed);
            }

            var forcedDisplayPrice = typeof cartItem.__kgForcedDisplayPriceMinor === "number"
                ? cartItem.__kgForcedDisplayPriceMinor
                : null;
            var displayDelta = typeof cartItem.__kgDisplayDeltaMinor === "number"
                ? cartItem.__kgDisplayDeltaMinor
                : 0;

            var finalDisplay = forcedDisplayPrice !== null
                ? Math.max(0, forcedDisplayPrice)
                : Math.max(0, baseDisplayed + displayDelta);

            if (priceGroupEl) priceGroupEl.style.display = "";
            priceEl.textContent = formatMoneyFromMinorUnits(finalDisplay, cart.currency);

            if (savingsEl) {
                if (cartItem.__kgDiscountedNonFree === true || displayDelta > 0) savingsEl.style.display = "none";
                else savingsEl.style.display = "";
            }
        }
    }

    function syncRenderedPrices(upcartRoot, cart) {
        // UpCart may re-render after cart-updated; apply prices across short ticks.
        renderCartItemPricesToDom(upcartRoot, cart);

        if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(function () {
                renderCartItemPricesToDom(upcartRoot, cart);
            });
        }

        setTimeout(function () {
            renderCartItemPricesToDom(upcartRoot, cart);
        }, 80);

        setTimeout(function () {
            renderCartItemPricesToDom(upcartRoot, cart);
        }, 220);
    }

    function getAppliedFreeCountFromDom(upcartRoot) {
        function normalizeSpaces(text) {
            var raw = (text || "").toLowerCase();
            var out = [];
            var prevWasSpace = false;
            for (var i = 0; i < raw.length; i += 1) {
                var ch = raw.charAt(i);
                var isSpace = ch === " " || ch === "\n" || ch === "\r" || ch === "\t";
                if (isSpace) {
                    if (!prevWasSpace) out.push(" ");
                    prevWasSpace = true;
                } else {
                    out.push(ch);
                    prevWasSpace = false;
                }
            }
            return out.join("").trim();
        }

        function textToFreeCount(text) {
            var txt = normalizeSpaces(text);
            if (
                txt.indexOf("3 + 2") !== -1 ||
                txt.indexOf("3+2") !== -1 ||
                txt.indexOf("buy 3, get 2 free") !== -1 ||
                txt.indexOf("buy 3 get 2 free") !== -1
            ) {
                return 2;
            }
            if (
                txt.indexOf("2 + 1") !== -1 ||
                txt.indexOf("2+1") !== -1 ||
                txt.indexOf("buy 2, get 1 free") !== -1 ||
                txt.indexOf("buy 2 get 1 free") !== -1
            ) {
                return 1;
            }
            return 0;
        }

        // 1) Prefer cart summary discount labels (single source for applied discount).
        if (upcartRoot && typeof upcartRoot.querySelectorAll === "function") {
            var summaryTags = upcartRoot.querySelectorAll(".upcart-internal-cart-summary .upcart-internal-component-tag__text, .upcart-public-cart-summary .upcart-public-component-tag__text");
            for (var s = 0; s < summaryTags.length; s += 1) {
                var fromSummary = textToFreeCount(summaryTags[s] && summaryTags[s].textContent);
                if (fromSummary > 0) return fromSummary;
            }
        }

        // 2) Fallback to per-line tags.
        var itemEls = getCartItemElements(upcartRoot);
        if (!itemEls || !itemEls.length) return 0;
        var detected = 0;
        for (var j = 0; j < itemEls.length; j += 1) {
            var tagTextEl = itemEls[j].querySelector(".upcart-internal-component-tag__text, .upcart-public-component-tag__text");
            if (!tagTextEl) continue;
            var fromLine = textToFreeCount(tagTextEl.textContent);
            if (fromLine > detected) detected = fromLine;
        }
        return detected;
    }

    function getFreeItemSplitValue(item) {
        if (!item || typeof item !== "object") return 0;
        var qtyRaw = Number(item.quantity);
        var qty = qtyRaw > 0 ? qtyRaw : 1;
        var line = 0;

        if (typeof item.finalLinePrice === "number") line = item.finalLinePrice;
        else if (typeof item.final_line_price === "number") line = item.final_line_price;
        else line = getItemUnitPrice(item) * qty;

        if (line <= 0) return 0;

        // If free item quantity > 1, split only one quantity's value.
        return qty > 1 ? Math.round(line / qty) : line;
    }

    function rebalanceTwoPlusOneFree(cart, upcartRoot) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length < 2) return;

        for (var r = 0; r < cart.items.length; r += 1) {
            cart.items[r].__kgDisplayDeltaMinor = 0;
            delete cart.items[r].__kgForcedDisplayPriceMinor;
            delete cart.items[r].__kgForcedDisplayText;
            delete cart.items[r].__kgDiscountedNonFree;
        }

        // Read applied discount from UpCart line-item tags first.
        // 2+1 FREE => 1 free line, 3+2 FREE => 2 free lines.
        var freeCount = getAppliedFreeCountFromDom(upcartRoot);
        if (freeCount !== 1 && freeCount !== 2) {
            freeCount = cart.items.length >= 5 ? 2 : 1;
        }
        freeCount = Math.min(freeCount, cart.items.length - 1);
        var freeItems = cart.items.slice(0, freeCount);
        var discountedItems = cart.items.slice(freeCount);
        if (!discountedItems.length) return;
        for (var d = 0; d < discountedItems.length; d += 1) {
            discountedItems[d].__kgDiscountedNonFree = true;
        }

        var totalFreeValue = 0;
        for (var f = 0; f < freeItems.length; f += 1) {
            var freeItem = freeItems[f];
            var freeValue = getFreeItemSplitValue(freeItem);
            totalFreeValue += freeValue;

            var freeQtyRaw = Number(freeItem.quantity);
            var freeQty = freeQtyRaw > 0 ? freeQtyRaw : 1;
            var freeLine = getItemLinePrice(freeItem);
            var freeUnit = freeQty > 0 ? Math.round(freeLine / freeQty) : freeLine;
            var restPrice = Math.max(0, freeLine - freeUnit);

            // Show "Free + rest" only for single-free offer (2+1).
            // For multi-free offers (e.g. 3+2), free items should be fully free.
            if (freeQty > 1 && freeCount === 1) {
                freeItem.__kgForcedDisplayText = "Free + " + formatMoneyFromMinorUnits(restPrice, cart.currency);
            } else {
                freeItem.__kgForcedDisplayPriceMinor = 0;
                freeItem.__kgForcedDisplayText = "Free";
            }
        }

        if (totalFreeValue <= 0) return;

        var split = Math.floor(totalFreeValue / discountedItems.length);
        var remainder = totalFreeValue - (split * discountedItems.length);
        for (var p = 0; p < discountedItems.length; p += 1) {
            var add = split + (p === 0 ? remainder : 0);
            discountedItems[p].__kgDisplayDeltaMinor = (discountedItems[p].__kgDisplayDeltaMinor || 0) + add;
        }

        console.log("[UpCart] split without properties:", {
            freeCount: freeCount,
            totalFreeValue: totalFreeValue,
            split: split,
            remainder: remainder,
            receivers: discountedItems.length
        });
    }

    function handleCartUpdated(cart) {
        var activeCart = cart || window.upcartCart || window.UpCartCart || window.cart;
        if (!activeCart || !Array.isArray(activeCart.items)) return activeCart;

        var upcartRoot = getUpcartRoot();
        console.log("[UpCart] root ready:", upcartRoot, "items:", activeCart.items.length);

        rebalanceTwoPlusOneFree(activeCart, upcartRoot);
        syncRenderedPrices(upcartRoot, activeCart);
        return activeCart;
    }

    function onCartUpdatedEvent(event) {
        var detail = event && event.detail ? event.detail : null;
        var detailCart = detail && detail.cart ? detail.cart : detail;
        logUpcartEventForTest(event, detailCart);
        handleCartUpdated(detailCart);
    }

    function logUpcartEventForTest(event, cart) {
        var name = event && event.type ? event.type : "unknown";
        var count = cart && Array.isArray(cart.items) ? cart.items.length : 0;
        console.log("[UpCart][TEST] event:", name, "items:", count, "detail:", event && event.detail);
    }

    // Listen on both window and UpCart shadow/document root.
    window.addEventListener("aftersell-upcart:public-events:cart-updated", onCartUpdatedEvent);
    window.addEventListener("aftersell-upcart:public-events:cart-loaded", onCartUpdatedEvent);

    var upcartRoot = getUpcartRoot();
    if (upcartRoot && upcartRoot !== window && typeof upcartRoot.addEventListener === "function") {
        upcartRoot.addEventListener("aftersell-upcart:public-events:cart-updated", onCartUpdatedEvent);
        upcartRoot.addEventListener("aftersell-upcart:public-events:cart-loaded", onCartUpdatedEvent);
    }
});
